import React from 'react';
import { ResponsiveTooltip, Typography } from '../../../../components';
import { PublicLinkItemData } from '../types';
import { STATUS_COLORS, getStatusLabels } from '../constants';
import { useTranslations } from '../../../../contexts/translation.context';
import { IcDate, RefreshGreyIc } from '../../../../components/icons';
import { Tooltip } from '@heroui/react';
import { formatTimeAgo } from '../../../../utils/formatTimeAgo';

interface StatusCellProps {
  item: PublicLinkItemData;
}

const StatusCell: React.FC<StatusCellProps> = ({ item }) => {
  const { t } = useTranslations();
  const statusLabels = getStatusLabels(t);

  const getStatusLabel = (status: string) => {
    return statusLabels[status as keyof typeof statusLabels] || status;
  };

  const getStatusColor = (status: string) => {
    return STATUS_COLORS[status as keyof typeof STATUS_COLORS] || 'bg-gray-400';
  };
  const interpolate = (template: string, vars: Record<string, any>): string => {
    return template.replace(/\{\{(\w+)\}\}/g, (_, key) => vars[key] ?? '');
  };

  return (
    <div className="flex flex-col gap-1 items-start">
      <div className="bg-zinc-100 flex h-6 items-center justify-center px-1 rounded-2">
        <div className="flex items-center pl-1 pr-0">
          <div className={`rounded-[9999px] size-[0.4375rem] ${getStatusColor(item.status)}`} />
        </div>
        <div className="flex gap-2.5 items-center justify-center px-1">
          <Typography variant="body3" className="text-auth-ink">
            {getStatusLabel(item.status)}
          </Typography>
        </div>
      </div>
      <ResponsiveTooltip
        content={
          <div className="flex flex-col">
            <Typography variant="body3" className="text-auth-muted">
              {t('partner.orders.createdAtOffer')}:
            </Typography>
            <Typography variant="body2">{formatTimeAgo(item.created_at, t)}</Typography>
          </div>
        }
        placement="top"
      >
        <div className="flex items-center gap-1 ">
          <IcDate className="w-3.5 h-3.5 text-gray-600" />
          <Typography variant="body3" className="text-gray-600">
            {formatTimeAgo(item.created_at, t)}
          </Typography>
        </div>
      </ResponsiveTooltip>
      <ResponsiveTooltip
        content={interpolate(t('partner.orders.tooltips.lastUpdated'), { date: item.created_at })}
        placement="top"
      >
        <div className="flex items-center gap-1">
          <RefreshGreyIc />
          <span className="text-xs leading-4 text-auth-muted">
            {formatTimeAgo(item.created_at, t)}
          </span>
        </div>
      </ResponsiveTooltip>
    </div>
  );
};

export default StatusCell;
